import { lazy, Suspense, useEffect, useMemo } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { ErrorView, LoadingScreen } from '@didaskill/ui/domain';
import { hide as hideSplashScreen, SentryErrorBoundary } from '@didaskill/ui/utils';

import { AuthGuard } from './generic/auth-guard';
import routes from './routes';
import LoginView from './views/login/LoginView';

const AuthenticatedAppRouter = lazy(() => import('./AuthenticatedAppRouter'));

const App = () => {
  useEffect(() => {
    hideSplashScreen();
  }, []);

  const router = useMemo(
    () =>
      createBrowserRouter(
        [
          {
            path: routes.LOGIN.ROOT,
            element: (
              <SentryErrorBoundary fallback={<ErrorView />}>
                <LoginView />
              </SentryErrorBoundary>
            ),
          },
          {
            path: '*',
            element: (
              <SentryErrorBoundary fallback={<ErrorView />}>
                <AuthGuard>
                  <AuthenticatedAppRouter />
                </AuthGuard>
              </SentryErrorBoundary>
            ),
          },
        ],
        {
          future: {
            v7_relativeSplatPath: true,
          },
        },
      ),
    [],
  );

  return (
    <Suspense fallback={<LoadingScreen />}>
      <RouterProvider router={router} future={{ v7_startTransition: true }} />
    </Suspense>
  );
};

export default App;
